import { render } from "./SideBarFooter.vue?vue&type=template&id=37f22a1f&scoped=true"
import script from "./SideBarFooter.vue?vue&type=script&lang=js"
export * from "./SideBarFooter.vue?vue&type=script&lang=js"

import "./SideBarFooter.vue?vue&type=style&index=0&id=37f22a1f&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-37f22a1f"]])

export default __exports__